import { CustomerServiceOutlined } from '@ant-design/icons';

import IssuePage from '../pages/IssuePage';

import { SiteMap } from './index';

export const issueRoutes: SiteMap = {
  crm: {
    title: '고객 관리',
    page: IssuePage,
    key: '/crm',
    icon: <CustomerServiceOutlined />,
    children: [
      {
        label: '통합 관리',
        icon: null,
        key: '/crm/board',
      },
      {
        label: '이슈 등록',
        icon: null,
        key: '/crm/register',
      },
      {
        label: '이슈 관리',
        icon: null,
        key: '/crm/manage',
      },
      {
        label: '이슈 히스토리',
        icon: null,
        key: '/crm/history',
      },
      {
        label: '매장별 이슈 관리',
        icon: null,
        key: '/crm/store-management',
      },
      {
        label: '물류 이슈 관리',
        icon: null,
        key: '/crm/logistics-management',
      },
      {
        label: '손실 책임 관리',
        icon: null,
        key: '/crm/liability-management',
      },
      {
        label: '영업 관리',
        icon: null,
        key: '/crm/sales-management',
      },
      {
        label: '이슈 출력',
        icon: null,
        key: '/crm/print',
      },
    ],
  },
};
